import React from 'react'
import '../scss/custom-loader.scss'

export default function Loading() {
    return (
        <div className='spinner'>

        </div>
    )
}
